// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/mask.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Signup_container__GzTz9 {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  z-index: 1;
}

.Signup_container__GzTz9::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Adjust the opacity as needed */
  z-index: -1;
}
  
  .Signup_formCard__JvMYT {
    background: rgba(31, 31, 31, 0.6);
    backdrop-filter: blur(10px);
    padding: 2rem;
    border-radius: 12px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .Signup_formCard__JvMYT h2 {
    color: white;
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 1.5rem;
  }
  
  .Signup_form__yB1Nh {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .Signup_inputGroup__3\\+FS8 {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
  }
  
  .Signup_inputGroup__3\\+FS8 input {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.05) !important;
    color: white;
    width: 100%;
  }
  
  .Signup_inputGroup__3\\+FS8 input::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  
  .Signup_passwordInput__vX7gF {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }
  
  .Signup_eyeIcon__z6V6u {
    position: absolute;
    right: 0.75rem;
    background: none;
    border: none;
    color: #ffffff;
    cursor: pointer;
    padding: 0;
  }
  .Signup_logoImage__7ELZF{
    width: 20px;
    height: 20px;
  }
  .Signup_logoappleImage__jvv34{
    width: 25px;
    height: 25px;
  }
  .Signup_checkboxGroup__eJi4d {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: white;
  }
  
  .Signup_checkboxGroup__eJi4d label {
    font-size: 0.875rem;
  }
  
  .Signup_errorInput__\\+f55D {
    border-color: #ff4444 !important;
  }
  
  .Signup_errorText__MfMu9 {
    color: #ff4444;
    font-size: 0.75rem;
  }
  
  .Signup_submitButton__T1nRL {
    background: #ff0000;
    color: white;
    padding: 0.75rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.2s;
  }
  
  .Signup_submitButton__T1nRL:hover {
    background: #cc0000;
  }
  
  .Signup_divider__L30us {
    display: flex;
    align-items: center;
    text-align: center;
    color: white;
    margin: 1rem 0;
  }
  
  .Signup_divider__L30us::before,
  .Signup_divider__L30us::after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .Signup_divider__L30us span {
    padding: 0 0.5rem;
    font-weight: 600;
  }
  
  .Signup_socialButtons__96DzF {
    display: flex;
    justify-content: space-between;
  }
  
  .Signup_googleButton__cOqR5,
  .Signup_appleButton__8LDSi {
    height: 30px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    color: black;
    cursor: pointer;
    transition: background-color 0.2s;
    background-color: white;
  }
  
  .Signup_googleButton__cOqR5:hover,
  .Signup_appleButton__8LDSi:hover {
    background: rgba(255, 255, 255, 0.5);
  }
  
  .Signup_loginLink__feTGD {
    text-align: center;
    color: white;
    font-size: 0.875rem;
    margin-top: 1rem;
    font-weight: 700;
  }
  
  .Signup_loginLink__feTGD a {
    color: #ff0000;
    text-decoration: none;
  }
  
  .Signup_loginLink__feTGD a:hover {
    text-decoration: underline;
  }
  .Signup_loadingWrapper__5b\\+6l {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  
  .Signup_spinner__FyC4u {
    animation: Signup_spin__vIIyf 1s linear infinite;
  }
  
  @keyframes Signup_spin__vIIyf {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  .Signup_submitButton__T1nRL.Signup_loading__awjeY {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  .Signup_submitButton__T1nRL:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  /* Style for disabled inputs */
  input:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
  
  button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .Signup_roleButtons__1XGaC {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  
  .Signup_roleButton__b2hUh {
    flex: 1 1;
    padding: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.05);
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 700;
  }
  
  .Signup_roleButton__b2hUh:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  
  .Signup_roleButton__b2hUh.Signup_active__kQGAJ {
    background: #ff0000;
    border-color: #ff0000;
    color: white;
  }
  
  .Signup_roleButton__b2hUh:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  /* Add this to your existing error styles */
  .Signup_errorText__MfMu9 {
    color: #ff4444;
    font-size: 0.75rem;
    display: block;
    margin-top: 0.25rem;
  }
  
  /* Responsive styles */
  @media (max-width: 480px) {
    .Signup_formCard__JvMYT {
      padding: 1.5rem;
    }
    
    .Signup_socialButtons__96DzF {
      flex-direction: column;
      gap: 10px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/auth/signup/Signup.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAAwD;EACxD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,iCAAiC;EACjE,WAAW;AACb;;EAEE;IACE,iCAAiC;IACjC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,gDAAgD;IAChD,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,SAAO;IACP,iDAAiD;EACnD;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;;IAEE,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,gDAAkC;EACpC;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA,2CAA2C;EAC3C;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,SAAS;IACX;EACF","sourcesContent":[".container {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-image: url('../../../public/images/mask.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding-top: 5rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  z-index: 1;\n}\n\n.container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Adjust the opacity as needed */\n  z-index: -1;\n}\n  \n  .formCard {\n    background: rgba(31, 31, 31, 0.6);\n    backdrop-filter: blur(10px);\n    padding: 2rem;\n    border-radius: 12px;\n    width: 100%;\n    max-width: 400px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .formCard h2 {\n    color: white;\n    text-align: center;\n    margin-bottom: 1.5rem;\n    font-size: 1.5rem;\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .inputGroup {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n  }\n  \n  .inputGroup input {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n    padding-left: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 6px;\n    background: rgba(255, 255, 255, 0.05) !important;\n    color: white;\n    width: 100%;\n  }\n  \n  .inputGroup input::placeholder {\n    color: rgba(255, 255, 255, 0.5);\n  }\n  \n  .passwordInput {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n  }\n  \n  .eyeIcon {\n    position: absolute;\n    right: 0.75rem;\n    background: none;\n    border: none;\n    color: #ffffff;\n    cursor: pointer;\n    padding: 0;\n  }\n  .logoImage{\n    width: 20px;\n    height: 20px;\n  }\n  .logoappleImage{\n    width: 25px;\n    height: 25px;\n  }\n  .checkboxGroup {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: white;\n  }\n  \n  .checkboxGroup label {\n    font-size: 0.875rem;\n  }\n  \n  .errorInput {\n    border-color: #ff4444 !important;\n  }\n  \n  .errorText {\n    color: #ff4444;\n    font-size: 0.75rem;\n  }\n  \n  .submitButton {\n    background: #ff0000;\n    color: white;\n    padding: 0.75rem;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: background-color 0.2s;\n  }\n  \n  .submitButton:hover {\n    background: #cc0000;\n  }\n  \n  .divider {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: white;\n    margin: 1rem 0;\n  }\n  \n  .divider::before,\n  .divider::after {\n    content: '';\n    flex: 1;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  .divider span {\n    padding: 0 0.5rem;\n    font-weight: 600;\n  }\n  \n  .socialButtons {\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .googleButton,\n  .appleButton {\n    height: 30px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 0.75rem;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 6px;\n    color: black;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    background-color: white;\n  }\n  \n  .googleButton:hover,\n  .appleButton:hover {\n    background: rgba(255, 255, 255, 0.5);\n  }\n  \n  .loginLink {\n    text-align: center;\n    color: white;\n    font-size: 0.875rem;\n    margin-top: 1rem;\n    font-weight: 700;\n  }\n  \n  .loginLink a {\n    color: #ff0000;\n    text-decoration: none;\n  }\n  \n  .loginLink a:hover {\n    text-decoration: underline;\n  }\n  .loadingWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n  }\n  \n  .spinner {\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .submitButton.loading {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n  \n  .submitButton:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n  \n  /* Style for disabled inputs */\n  input:disabled {\n    background-color: #f5f5f5;\n    cursor: not-allowed;\n  }\n  \n  button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n  .roleButtons {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n  }\n  \n  .roleButton {\n    flex: 1;\n    padding: 0.75rem;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 6px;\n    background: rgba(255, 255, 255, 0.05);\n    color: white;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-weight: 700;\n  }\n  \n  .roleButton:hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n  \n  .roleButton.active {\n    background: #ff0000;\n    border-color: #ff0000;\n    color: white;\n  }\n  \n  .roleButton:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n  \n  /* Add this to your existing error styles */\n  .errorText {\n    color: #ff4444;\n    font-size: 0.75rem;\n    display: block;\n    margin-top: 0.25rem;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 480px) {\n    .formCard {\n      padding: 1.5rem;\n    }\n    \n    .socialButtons {\n      flex-direction: column;\n      gap: 10px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Signup_container__GzTz9`,
	"formCard": `Signup_formCard__JvMYT`,
	"form": `Signup_form__yB1Nh`,
	"inputGroup": `Signup_inputGroup__3+FS8`,
	"passwordInput": `Signup_passwordInput__vX7gF`,
	"eyeIcon": `Signup_eyeIcon__z6V6u`,
	"logoImage": `Signup_logoImage__7ELZF`,
	"logoappleImage": `Signup_logoappleImage__jvv34`,
	"checkboxGroup": `Signup_checkboxGroup__eJi4d`,
	"errorInput": `Signup_errorInput__+f55D`,
	"errorText": `Signup_errorText__MfMu9`,
	"submitButton": `Signup_submitButton__T1nRL`,
	"divider": `Signup_divider__L30us`,
	"socialButtons": `Signup_socialButtons__96DzF`,
	"googleButton": `Signup_googleButton__cOqR5`,
	"appleButton": `Signup_appleButton__8LDSi`,
	"loginLink": `Signup_loginLink__feTGD`,
	"loadingWrapper": `Signup_loadingWrapper__5b+6l`,
	"spinner": `Signup_spinner__FyC4u`,
	"spin": `Signup_spin__vIIyf`,
	"loading": `Signup_loading__awjeY`,
	"roleButtons": `Signup_roleButtons__1XGaC`,
	"roleButton": `Signup_roleButton__b2hUh`,
	"active": `Signup_active__kQGAJ`
};
export default ___CSS_LOADER_EXPORT___;
